import { Ajax } from '@bamboohr/utils';

export function getInvoicesExport(invoiceIds) {
	return Ajax.get('/settings/account/billing/invoices/export', { invoiceIds });
}
